<template>
  <div class="accordion container" role="tablist">
    <b-row>
        <b-col md="8" sm="12">
            <h1 class="color-brand-4 tw-text-24px tw-font-medium">Călători și acoperire</h1>
            <h3 class="tw-text-16px md:tw-text-18px color-brand-4 text-uppercase pt-4 mb-2">
                Acoperirile de bază ale asigurării de călătorie
            </h3>
            <p class="color-brand-4 md:tw-text-16px tw-text-14px tw-font-light mb-3 py-2">
                Acoperirile de bază ale asigurării de călătorie includ urgențele medicale care necesită asistență
                medicală sau repatriere în țară, precum și decesul asiguratului și repatrierea acestuia.<br/>
                Această poliță, fără adăugarea de acoperiri suplimentare, acoperă doar călătoriile cu scopul ales în
                primul pas și nu cu alte scopuri (ex. exercitarea profesiei)
            </p>
        </b-col>
    </b-row>

      <hr class="tw-border-t-2 border-brand-3">

      <b-card class="border-white" v-for="(traveler, idx) in travelers" :key="idx" :set="v = $v.travelers.$each[idx]">
        <b-card-header header-tag="header" class="bg-white border-white px-0" role="tab" @click="switchToIndex(idx)">
          <div class="w-100 d-flex justify-content-between">
            <b-button variant="primary"
                      class="text-decoration-none tw-text-hover md:tw-text-16px color-brand-3 tw-border-2 border-brand-3 color-brand-3 text-uppercase tw-font-medium mb-3 hover:tw-text-white hover-bg-brand-3 btn-custom">
              Călător {{
                idx + 1
              }}{{ (editedTravelerIdx !== idx) ? `: ${traveler.firstName} ${traveler.lastName}` : '' }}
              <i v-if="v.$error" style="font-size: 20px; color: orange;" class="fas fa-exclamation pt-1"></i>
            </b-button>
            <CollectorDataIcons :collector="collector" v-if="editedTravelerIdx !== idx"></CollectorDataIcons>
            <b-button variant="link" class="text-decoration-none color-brand-3 tw-text-18px hover-color-brand-4"
                      size="md" @click="removeTraveler(idx)" :disabled="travelers.length === 1">
              <span class="fa fa-times"></span>
            </b-button>
          </div>
          <b-form-checkbox class="py-2" v-model="traveler.coverages.accident" v-if="editedTravelerIdx !== idx">
              Doresc să mă asigur împotriva accidentelor
          </b-form-checkbox>
        </b-card-header>
        <b-collapse :id="'accordion-'+idx" :visible="editedTravelerIdx === idx" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-row class="mb-4">
              <b-col md="8" sm="12">
                <b-row class="bg-light-custom rounded">
                    <b-col md="7" sm="12" class="pt-3">
                        <label class="tw-text-primary-gray small" for="select_traveler">
                            Selectează o persoană din contul tău:
                        </label>
                        <select id="select_traveler"
                                class="tw-border-third-gray hover:tw-border-green form-control rounded mb-3"
                                @change="autocompleteSavedTraveler(idx)" :disabled="!savedTravelers.length"
                                v-model="traveler.selectedTraveler">
                            <option :value="null">Selectează o persoană</option>
                            <option v-for="(savedTraveler) in savedTravelers" :value="savedTraveler.cnp">
                                {{ savedTraveler.firstName }} {{ savedTraveler.lastName }}
                            </option>
                        </select>
                        <p class="tw-text-primary-gray small">Sau adaugă una nouă:</p>
                        <input :id="'input_last_name_' + idx" type="text" class="form-control my-3" placeholder="Nume" :ref="'nume-' + idx"
                            :class="status(v.lastName)" v-model="traveler.lastName">
                        <input id="input_first_name" type="text" class="form-control my-3" placeholder="Prenume" :ref="'prenume-' + idx"
                            :class="status(v.firstName)" v-model="traveler.firstName">
                        <input id="input_cnp" type="text" class="form-control my-3" placeholder="CNP" :ref="'cnp-' + idx"
                            :class="status(v.cnp)" v-model="traveler.cnp">

                        <select :id="'select_amount_insured_' + idx" :ref="'amount-' + idx" v-on:change="traveler.coverages.storno = false"
                                class="tw-border-third-gray hover:tw-border-green form-control rounded mb-3"
                                v-model="traveler.amount_insured_id">
                            <option :value="1">10.000 EURO</option>
                            <option :value="2">30.000 EURO</option>
                            <option :value="3">50.000 EURO</option>
                        </select>

                        <hr v-if="traveler.coverages.roadAssist"/>
                        <input v-if="traveler.coverages.roadAssist || collector.transport === 'Masina' || collector.transport === 'Avion+Masina inchiriata'"
                                id="input_registration_number" type="text" class="form-control my-3" :ref="'nrinmatriculare-' + idx"
                                placeholder="Nr. înmatriculare"
                                :class="status(v.registrationNumber)" v-model="traveler.registrationNumber">
                        <div v-if="traveler.coverages.roadAssist">
                        <input id="input_vin" type="text" class="form-control my-3" placeholder="Serie șasiu" :ref="'seriesasiu-' + idx"
                                :class="status(v.vin)" v-model="traveler.vin">
                        </div>
                    </b-col>

                    <b-col md="5" sm="12" class="p-0 m-0">
                        <CollectorData :collector="collector"></CollectorData>
                    </b-col>
                </b-row>
              </b-col>

              <b-col md="4" sm="12">
                <h2 class="tw-text-16px md:tw-text-18px color-brand-4 text-uppercase pb-3 mb-3 tw-border-b-2 border-brand-2">
                  Acoperire</h2>
                <small class="tw-text-primary-gray">
                    Acoperirile de bază ale asigurării de călătorie includ urgențele medicale care necesită asistență
                    medicală sau repatriere în țară, precum și decesul asiguratului și repatrierea acestuia. Această
                    poliță acoperă doar călătoriile în scop turistic, și nu cu alte scopuri (ex. exercitarea profesiei).
                </small>
                <h2 class="tw-text-16px md:tw-text-18px color-brand-4 text-uppercase py-4">
                    Ia-ți acoperire premium
                </h2>
                <small class="tw-text-primary-gray">
                    Cu acoperirea Premium poți include în asigurare și următoarele riscuri:
                </small>
                <b-form-checkbox class="py-2" v-model="traveler.coverages.accident">
                    Doresc să mă asigur împotriva accidentelor
                </b-form-checkbox>
                <b-form-checkbox class="py-2"
                                 v-if="collector.transport === 'Avion' || collector.transport === 'Avion+Masina inchiriata'"
                                 v-model="traveler.coverages.baggage">
                    Doresc să îmi asigur bagajele<br />
                    <small class="tw-text-primary-gray">
                        <img src="/assets/ic_info.png" alt="Info" class="d-inline" width="16" />
                        În cazul călătoriei cu avionul, prin polița de asigurare încheiată la societatea de
                        asigurare <b>Groupama</b> implicit sunt asigurate și bagajele.
                    </small>
                </b-form-checkbox>
                <b-form-checkbox class="pt-2" v-model="traveler.coverages.rca">
                    Doresc să îmi asigur răspunderea civilă<br>
                  <small class="tw-text-primary-gray">
                      Vătămări corporale din culpă a unor terțe persoane, prejudicii materiale cauzate de asigurat
                  </small>
                </b-form-checkbox>
                <b-form-checkbox class="py-2" v-if="collector.transport === 'Masina'"
                                 v-model="traveler.coverages.roadAssist">
                    Doresc asigurare de asistență rutieră pe perioada călătoriei
                </b-form-checkbox>
                <b-form-checkbox class="py-2" v-model="traveler.coverages.sports">
                    Voi practica activități sportive
                </b-form-checkbox>
                  <small class="tw-text-primary-gray" v-if="traveler.amount_insured_id !== 1">
                      Dacă se dorește acoperire pentru anularea călătoriei (storno) completează formularul de comandă
                      sau de contact și un consultant FDA îți va întocmi o ofertă de poliță medicală și storno.
                  </small>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
        <hr class="tw-border-t-2 border-brand-3">
      </b-card>

      <b-row class="mb-5 mt-3">

        <b-col md="5" sm="12">
            <button class="btn btn-custom btn-custom-lg bg-brand-2 hover-bg-brand-4 hover:tw-text-white mb-5 mt-3" @click="addTraveler">
                + Adaugă călător
            </button>
            <h2 class="tw-text-14px md:tw-text-16px pb-2 color-brand-4 mb-3">
                Dorești consultanță în alegerea tipului de asigurare?
            </h2>
            <a href="https://fabricadeasigurari.ro/petitions?it=calatorie" target="_blank" class="d-block mb-5">
                <button class="btn tw-border-1 border-brand-4 color-brand-4 hover-bg-brand-4 hover:tw-text-white btn-custom">
                    Da, doresc consultanță
                </button>
            </a>
            <button variant="primary" class="btn btn-primary bg-brand-1 hover-bg-brand-4 btn-custom btn-custom-lg mb-4" @click="nextStep">
                Continuă
            </button>
        </b-col>

        <b-col class="col-md-7 col-sm-12 d-flex justify-content-center align-items-center" style="z-index: 1">
           <div class="bg-image bg-mobile w-100 h-100 rounded">&nbsp;</div>
        </b-col>

      </b-row>

  </div>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {alphaNum, required, requiredIf, maxLength, minLength, minValue, maxValue} from 'vuelidate/lib/validators';
import {cnp, regNr} from '../validations';
import {
  ADD_TRAVELER, FETCH_CITIES,
  FETCH_COLLECTOR, FETCH_EUROINS_BRANDS,
  FETCH_SAVED_TRAVELERS,
  REMOVE_TRAVELER, SAVE_TRAVELERS, SET_TRAVELERS
} from "../store/travel.module";
import {mapGetters} from "vuex";
import EventBus from '../eventbus';
import CollectorData from "./CollectorData";
import CollectorDataIcons from "./CollectorDataIcons";

export default {
  name: "TravelCoverage",
  metaInfo: {
    title: 'Calatori si acoperire - Asigurare calatorie online - Fabrica de Asigurari',
  },
  components: {CollectorData, CollectorDataIcons},
  data() {
    return {
      editedTravelerIdx: 0,
      consulting: true
    }
  },
  computed: {
    ...mapGetters(['travelers', 'savedTravelers', 'isLoggedIn', 'collector', 'euroinsBrands']),
    isMobile() {
      return window.screen.width < 575.98;
    }
  },
  created() {
    this.initialize()
  },
  mounted() {
    this.$router.push('/asigurare-de-calatorie/calatori-si-acoperire');
    $('#input_last_name_0').focus();
    paintFilledFields();
  },
  methods: {
    initialize() {
      this.$store.dispatch(FETCH_SAVED_TRAVELERS)
      this.$store.dispatch(FETCH_COLLECTOR);
      this.$store.dispatch(FETCH_EUROINS_BRANDS);
    },
    nextStep() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        setTimeout(() => {
          for (let input in this.$refs) {
            if($(this.$refs[input][0]).hasClass('error')) {
              this.$refs[input][0].focus();
            }
          }
        }, 0);
      } else {
        EventBus.$emit('next-step');
      }
    },
    status(validation) {
      if (!validation) return {};
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    switchToIndex(idx) {
      this.editedTravelerIdx = idx;
      this.$v.$touch();
    },
    setCityName(index) {
      for (let key in this.travelers[index].cities) {
        if (this.travelers[index].city === key) {
          this.travelers[index].cityName = this.travelers[index].cities[key];
        }
      }
    },
    async autocompleteSavedTraveler(idx) {
      if (this.travelers[idx].selectedTraveler) {
        for (let traveler of this.savedTravelers) {
          if (traveler.cnp === this.travelers[idx].selectedTraveler)
            this.travelers[idx] = Object.assign(this.travelers[idx], traveler);

          this.$store.dispatch(FETCH_CITIES, {index: idx, countyId: this.travelers[idx].county})
              .then(() => this.setCityName(idx))
              .catch(err => console.log(err));

          this.$v.$touch();
        }
      } else {
        this.travelers[idx].firstName = ''
        this.travelers[idx].lastName = ''
        this.travelers[idx].cnp = ''
        this.travelers[idx].idType = ''
        this.travelers[idx].idSeries = ''
        this.travelers[idx].idNumber = ''
        this.travelers[idx].county = ''
        this.travelers[idx].city = ''
        this.travelers[idx].street = ''
        this.travelers[idx].number = ''
        this.travelers[idx].building = ''
        this.travelers[idx].entry = ''
        this.travelers[idx].floor = ''
        this.travelers[idx].email = ''
        this.travelers[idx].phone = ''
        this.travelers[idx].registrationNumber = ''
        this.travelers[idx].vin = ''
      }
    },
    addTraveler() {
      this.$v.$touch()
      if (this.$v.$anyError) return;

      console.log('here: ' + $('#select_amount_insured_0').val());
      this.$store.commit(ADD_TRAVELER, $('#select_amount_insured_0').val());
      this.editedTravelerIdx = this.travelers.length - 1;
      setTimeout(() => {
        $('#input_last_name_' + (this.travelers.length - 1)).focus();
        paintFilledFields();
      }, 300);
    },
    removeTraveler(idx) {
      this.$store.commit(REMOVE_TRAVELER, idx);
      setTimeout(() => {
        this.editedTravelerIdx = this.travelers.length - 1;
        paintFilledFields();
      }, 500)
    }
  },
  mixins: [validationMixin],
  validations() {
    return {
      travelers: {
        $each: {
          firstName: {
            required,
            minLength: minLength(3)
          },
          lastName: {
            required,
            minLength: minLength(3)
          },
          cnp: {
            required,
            cnp: cnp
          },
          registrationNumber: {
            requiredIf: requiredIf((traveler) => {
              return traveler.coverages.roadAssist
            }),
            regNr: regNr,
            minLength: minLength(6)
          },
          vin: {
            requiredIf: requiredIf((traveler) => {
              return traveler.coverages.roadAssist
            }),
            alphaNum: alphaNum,
            length: (v) => !v || v.length === 17 || v.length === 0
          }
        }
      }
    }
  }
}
</script>

<style scoped>

.error {
  border-color: orange !important;
  /*background: #FDD;*/
}

.error:focus {
  outline-color: #F99;
}

.card > .card-body {
    padding-left: 0;
    padding-right: 0;
}
</style>
